import { z } from 'zod';

export const Tags = z.enum(['poblano', 'capsicum', 'wc-pledge', 'fto']).describe('Update this schema to add new tags');

export const TagSchema = z.array(Tags).nonempty().optional();
export type TagSchema = z.infer<typeof TagSchema>;
